import StyledTextField from '@shared/components/core/field/StyledTextField';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { useTranslation } from 'react-i18next';

function OtherControlField({ value, onChange, disabled }: IControlFieldProps) {
    const { t } = useTranslation();
    return (
        <StyledTextField
            fullWidth
            disabled={disabled}
            type="text"
            value={value}
            label={t('common:other.label')}
            placeholder={t('common:other.placeholder')}
            onChange={(e) => onChange(e.target.value)}
        />
    );
}

export default OtherControlField;
